import AssetsTableFilter from './AssetsTableFilter';
import {Col, Row, Space} from 'antd';
import {capitalize} from 'lodash';
import {useTranslation} from 'react-i18next';
import {getTranslationAssetTableColumnKey} from '../../../utils/translation';
import {useDispatch, useSelector} from 'react-redux';
import {addSorters, removeSorters, selectAssetsTableSorters} from '../../../redux/slices/assets';
import TableSorter from '../../common/TableSorter';
import {AssetsTableStaticColumn, isAssetsTableStaticColumn} from '../../../types/internal/tables/assetsTable';
import {useGetHazardTypeClassesQuery} from '../../../redux/api/hazardTypes';
import {useGetAssetBiodiversityDataSourcesQuery} from "../../../redux/api/asset";
import {useGetAlertParametersTypeQuery} from "../../../redux/api/alertParameters";

export default function AssetsTableColumnHeader({column}: { column: AssetsTableStaticColumn | string }) {

  const {t} = useTranslation();
  const dispatch = useDispatch();
  const currentSorters = useSelector(selectAssetsTableSorters);

  let filter = <></>;
  let sorter = <></>;
  let title = '';

  const {
    data: hazardTypes,
  } = useGetHazardTypeClassesQuery();
  const {
    data: biodiversitySources,
  } = useGetAssetBiodiversityDataSourcesQuery()
  const {
    data: alertParametersTypeSources
  } = useGetAlertParametersTypeQuery({paginate: false})

  const bioSource = biodiversitySources?.find(bs => bs.value === column)?.label
  const hazard = hazardTypes?.find(ht => ht.code === column)?.name;
  const alertParameter = alertParametersTypeSources?.find(param => param.code === column)?.label

  if (isAssetsTableStaticColumn(column)) {
    title = capitalize(t(getTranslationAssetTableColumnKey(column)));
  } else {

    if (bioSource) {
      title = `${capitalize(t("assets.landCoveragePercentage"))} ${bioSource}`
    }
    if (hazard) {
      title = capitalize(hazard);
    }
    if (alertParameter) {
      title = capitalize(alertParameter)
    }
  }

  switch (column) {
    case 'map_view':
      break;
    default:
      if (bioSource) {
        sorter = <TableSorter
          onChange={(type) => {
            if (type) {
              dispatch(addSorters({[`overall_land_coverage_${column}`]: type || undefined}));
            } else {
              dispatch(removeSorters(`overall_land_coverage_${column}`));
            }
          }}
          value={currentSorters[`overall_land_coverage_${column}`] || null}
        />;
      } else {
        sorter = <TableSorter
          onChange={(type) => {
            if (type) {
              dispatch(addSorters({[column]: type || undefined}));
            } else {
              dispatch(removeSorters(column));
            }
          }}
          value={currentSorters[column] || null}
        />;
      }


      filter = <AssetsTableFilter column={column}/>;
      break;
  }

  return <Row align={'middle'} wrap={false}>
    <Col flex={1} style={{marginRight: '0.5rem'}}>
      {title}
    </Col>
    <Col>
      <Space>
        {sorter}
        {filter}
      </Space>
    </Col>
  </Row>;
}